import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79006330"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "settings-title"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { id: "settings-title" }, "Settings"),
  /*#__PURE__*/_createElementVNode("p", { class: "modal-subtitle" }, "Choose your voting scale")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 6L6 18M6 6L18 18",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "options-grid" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "option-name" }
const _hoisted_9 = { class: "option-values" }

import GameFormat from '@/view-models/gameFormat';



export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsModal',
  emits: ['saveSettings', 'close'],
  setup(__props, { emit: __emit }) {

let gameFormats = JSON.parse(localStorage.getItem('gameTypes') || '[]');

const emit = __emit

function saveSettings(vote: GameFormat) {
  emit('saveSettings', vote);
}

function close() {
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-backdrop",
    onClick: _withModifiers(close, ["self"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "modal-header" }, [
        _hoisted_2,
        _createElementVNode("button", {
          class: "close-btn",
          onClick: close,
          "aria-label": "Close"
        }, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameFormats), (format) => {
            return (_openBlock(), _createElementBlock("button", {
              key: `format-${format.name}`,
              class: "option-card",
              onClick: () => saveSettings(format)
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(format.name), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(format.values?.slice(0, 5).join(', ')) + _toDisplayString(format.values?.length > 5 ? '...' : ''), 1)
            ], 8, _hoisted_7))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})